// source: pbtypes/gen/streaming_bitrate_controller/link_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.streaming_bitrate_controller.LinkType', null, global);
goog.exportSymbol('proto.streaming_bitrate_controller.LinkType.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.streaming_bitrate_controller.LinkType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.streaming_bitrate_controller.LinkType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.streaming_bitrate_controller.LinkType.displayName = 'proto.streaming_bitrate_controller.LinkType';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.streaming_bitrate_controller.LinkType.prototype.toObject = function(opt_includeInstance) {
  return proto.streaming_bitrate_controller.LinkType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.streaming_bitrate_controller.LinkType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.streaming_bitrate_controller.LinkType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.streaming_bitrate_controller.LinkType}
 */
proto.streaming_bitrate_controller.LinkType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.streaming_bitrate_controller.LinkType;
  return proto.streaming_bitrate_controller.LinkType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.streaming_bitrate_controller.LinkType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.streaming_bitrate_controller.LinkType}
 */
proto.streaming_bitrate_controller.LinkType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.streaming_bitrate_controller.LinkType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.streaming_bitrate_controller.LinkType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.streaming_bitrate_controller.LinkType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.streaming_bitrate_controller.LinkType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.streaming_bitrate_controller.LinkType.Enum = {
  KUNKNOWN: 0,
  KDIRECTWIFI: 1,
  KLTE: 2,
  KREMOTEUPLINK: 3,
  KQGC: 4,
  KDOCK: 5,
  KACCESSPOINT: 6,
  KLTE_0: 7,
  KLTE_1: 8,
  KLTE_2: 9,
  KLTE_3: 10,
  KLTE_4: 11,
  KLTE_5: 12,
  KCONTROLLER: 13,
  KEXTERNALNETWORK: 14,
  KMICROHARD: 15,
  LAST: 16
};

goog.object.extend(exports, proto.streaming_bitrate_controller);
